// Librairies
import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

// Services
import { AuthService } from 'src/app/services/core/auth.service';
import { SynthesisStore } from 'src/app/services/stores/synthesis.store';

// Interfaces
import { CompanyDetail, NamedRef, Tenant } from 'src/app/interfaces/api/company';

// Components
import { NoDataComponent } from 'projects/ui-library/src/lib/components/no-data/no-data.component';
import { ButtonComponent, SpinnerComponent } from 'ui-library';

// /synthesis: one card per tenant of the current company.
@Component({
  selector: 'app-tenant-picker',
  standalone: true,
  imports: [
    MatIconModule,
    MatMenuModule,
    RouterLink,
    TranslateModule,
    ButtonComponent,
    SpinnerComponent,
    NoDataComponent
  ],
  templateUrl: './tenant-picker.component.html',
  styleUrl: './tenant-picker.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class TenantPickerComponent {
  // Services
  readonly store: SynthesisStore = inject(SynthesisStore);
  private readonly authService: AuthService = inject(AuthService);
  private readonly router: Router = inject(Router);

  // Signals
  readonly company: Signal<CompanyDetail | null> = this.store.company;
  readonly tenants: Signal<Tenant<NamedRef>[]> = this.store.tenants;
  readonly canManageTenants: Signal<boolean> = this.authService.canManageProject;


  // Not a routerLink: lib-button stops the click propagation, so a routerLink on its host never fires.
  createTenant(): void {
    this.router.navigate(['/company']);
  }
}
